import React, { useRef } from "react";
import LabelContainer from "../LabelContainer";
import EmptyButton from "./EmptyButton";

const ImageInput = ({
  k = -1,
  autoFocus,
  autocomplete = "on",
  inputStyle = {},
  inputClassName = "",
  type,
  disabled = false,
  id = null,
  value,
  change = () => {},
  placeholder = "",
  ...props
}) => {
  const inputRef = useRef(null);
  const valueChange = (e) => {
    let filteredValue = e.target.files;

    let changeEvent = {
      target: {
        name: props.name,
        value: filteredValue,
        k: k,
      },
    };

    change(changeEvent);
  };
  return (
    <LabelContainer {...props} value={value}>
      <input
        ref={inputRef}
        autoFocus={autoFocus}
        autoComplete={autocomplete}
        style={inputStyle}
        className={"form-control " + inputClassName}
        type="file"
        disabled={disabled ? "disabled" : false}
        id={k != -1 ? props.name + "-" + k : id ? id : props.name}
        name={props.name}
        files={value}
        onChange={valueChange}
        placeholder={placeholder}
        accept="image/png, image/jpeg"
        multiple
      />
      {!disabled && !props.hideEmptyBtn && (
        <EmptyButton
          change={change}
          name={props.name}
          targetInput={inputRef}
          value={value}
        />
      )}
    </LabelContainer>
  );
};

export default ImageInput;
